module.exports = __webpack_public_path__ + "228fa19ba40f8b80ec58af7a3c44da56.eot";